module.exports = __webpack_public_path__ + "img/C1_HQ02.67f5bcbf.jpg";